import {useState} from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Grid';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Typography } from "@mui/material";
import ResultsPane from './ResultsPane';
import ProjectPopover from './ProjectPopover';

const theme = createTheme({
  typography: {
    fontFamily: ["Radio Canada Big", "Arial"].join(",")
  }
});

function ApproveProjects(props) {
    const [activeResult, setActiveResult] = useState(null);
    const [ projects, setProjects ] = useState([]);
    const [ filteredProjects, setFilteredProjects ] = useState([]);
    const [ organisations, setOrganisations ] = useState([]);
    const [ techProviders, setTechProviders ] = useState([]);
    const [ admin, setAdmin ] = useState(true);
    const [ refreshList, setRefreshList ] = useState(false);

    const selectedResult = (result) => {
      setActiveResult(result);
  }

  return (
<ThemeProvider theme={theme}>
    <Box sx={{ flexGrow: 1 }}>
        <Box sx={{ backgroundColor: '#ffffff', padding: '20px', width: '70%', marginLeft: 'auto', marginRight: 'auto'}}>
          <Typography variant="h2" color="common.white" sx={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>SEA-TECH-IN-MOTION ADMIN</Typography>
        </Box>

        <Card sx={{backgroundColor: '#f1f1f1', width: '95%', marginLeft: 'auto', marginRight: 'auto'}}>
          <ResultsPane {...props} {...{admin, refreshList, setRefreshList, projects, setProjects, organisations, setOrganisations, 
            techProviders, setTechProviders, filteredProjects, setFilteredProjects}} onSelectResult={selectedResult} />
        </Card>
    </Box>
    <ProjectPopover {...props} {...{ admin, setRefreshList, activeResult, setActiveResult, organisations, techProviders }} />
</ThemeProvider>
  );
}

export default ApproveProjects;
